import React from 'react';
import HomeNavBar from '../HomePage/HomeNavBar';
import LeftSidebar from '../HomePage/LeftSidebar';
import { ReactComponent as DownloadText } from '../../assets/icons/download-text.svg';
import { ReactComponent as MacCard } from '../../assets/cards/mac.svg';
import { ReactComponent as WindowsCard } from '../../assets/cards/windows.svg';
import { ReactComponent as LinuxCard } from '../../assets/cards/linux.svg';
import { useNavbarUser } from '../../utils/navbarUser';
import './DownloadPage.css';

const DOWNLOADS = [
  {
    name: 'Mac',
    label: 'Installer',
    href: '/downloads/PolarAce-Installer.pkg',
    ariaLabel: 'Download for Mac',
    Card: MacCard,
  },
  {
    name: 'Windows',
    label: 'Installer',
    href: '/downloads/PolarAce-Setup.exe',
    ariaLabel: 'Download for Windows',
    Card: WindowsCard,
  },
  {
    name: 'Linux',
    label: 'Preview',
    href: '/downloads/PolarAce-linux-preview.zip',
    ariaLabel: 'Download for Linux',
    Card: LinuxCard,
  },
];

function DownloadPage() {
  const user = useNavbarUser({});

  return (
    <div className="download-page">
      <HomeNavBar
        spadesBalance={user.spades}
        notificationCount={user.notifications}
        userAvatar={user.avatar}
        userName={user.name}
        onSpadesClick={() => {}}
        minimal
      />
      <LeftSidebar />
      <main className="download-page__main">
        <div className="download-page__content">
          <div className="download-page__header">
            <DownloadText
              viewBox="710 0 180 46"
              width="180"
              height="46"
              className="download-page__title-svg"
              aria-label="Download"
            />
            <p className="download-page__subheading">
              Download the Polar Ace OBS plugin.
            </p>
          </div>
          <div className="download-page__cards">
            {DOWNLOADS.map(({ name, label, href, ariaLabel, Card }) => (
              <a
                key={name}
                href={href}
                className="download-page__card-btn"
                aria-label={ariaLabel}
                download
              >
                <Card className="download-page__card-svg" />
                <span className="download-page__card-meta">
                  <span className="download-page__card-name">{name}</span>
                  <span className="download-page__card-label">{label}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default DownloadPage;
